import React, { FC, ReactNode, useEffect, useState } from 'react'

export interface IAEATabProps{
    active?: boolean;
    title: any;
    children?: ReactNode;
    onClick?: () => void;
    onChangeTab?: () => void;
}

const AEATab: FC<IAEATabProps> = (props: IAEATabProps) => {

    useEffect(() => {
        if ((props.active && typeof props.onChangeTab === 'function')){
            props.onChangeTab();
        }
    }, [props.active])
    
    return (
        <div>{props.children}</div>
    )
}

export default AEATab
